export default __webpack_public_path__ + "static/media/success-sign.4feeaa82.png";